import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { URLGuard } from './gurd.guard';
import { PartnerGuard } from './services/partner.guard';
import { BusinessDetailComponent } from './components/business-detail/business-detail.component';
import { LandingPageComponent } from './components/landing-page/landing-page.component';
import { HomeComponent } from './components/home/home.component';
import { GuidePagesComponent } from './components/guide-pages/guide-pages.component';
import { NewsComponent } from './components/news/news.component';
import { NewTripComponent } from './components/trip/new-trip/new-trip.component';
import { AllTripComponent } from './components/trip/all-trip/all-trip.component';
import { ProfileComponent } from './components/profile/profile.component';
import { SupportComponent } from './components/support/support.component';
import { PaymentComponent } from './components/payment/payment.component';
import { HomeMarketersComponent } from './components/marketers/home-marketers/home-marketers.component';
import { PartnerDashboardComponent } from './components/_Partners/partner-dashboard/partner-dashboard.component';
import { PartnerTripsComponent } from './components/_Partners/partner-trips/partner-trips.component';
import { PartnerFinancialComponent } from './components/_Partners/partner-financial/partner-financial.component';
import { DriverAdsComponent } from './components/driver-ads/driver-ads.component';
import { TaxilonAdsDetailComponent } from './components/taxilon-ads-detail/taxilon-ads-detail.component';
import { TruckValidateComponent } from './components/truck-validate/truck-validate.component';
import { EducationComponent } from './education/education.component';
import { RouteComponent } from './components/route/route.component';
import { FullPaymentComponent } from './full-payment/full-payment.component';
import { BusinessComponent } from './components/business/business.component';
import { BusinessPageComponent } from './components/business-page/business-page.component';

const routes: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: '', component: LandingPageComponent, children: [
      { path: 'home', component: HomeComponent },
      { path: 'login/:redirectTo', component: BusinessDetailComponent },
      { path: 'login/:redirectTo/:id', component: BusinessDetailComponent },
      { path: 'new-request', component: NewTripComponent, canActivate: [URLGuard] },
      { path: 'all-request', component: AllTripComponent, canActivate: [URLGuard] },
      { path: 'news', component: NewsComponent },
      { path: 'news/:id', component: NewsComponent },
      { path: 'News/:id', component: NewsComponent },
      { path: 'about', component: GuidePagesComponent },
      { path: 'general', component: GuidePagesComponent },
      { path: 'drivers', component: GuidePagesComponent },
      { path: 'privacy', component: GuidePagesComponent },
      { path: 'contact-us', component: GuidePagesComponent },
      { path: 'truck-validate', component: TruckValidateComponent },
      { path: 'emdadran', component: GuidePagesComponent },
      { path: 'jobs', component: DriverAdsComponent },
      { path: 'job/:id', component: TaxilonAdsDetailComponent },
      { path: 'job/:title/:id', component: TaxilonAdsDetailComponent },
      { path: 'educations', component: EducationComponent },
      { path: 'education/:id', component: EducationComponent },
      { path: 'Profile', component: ProfileComponent, canActivate: [URLGuard] },
      { path: 'support', component: SupportComponent, canActivate: [URLGuard] },
      { path: 'route/:id', component: RouteComponent, canActivate: [URLGuard] },
      { path: 'business', component: BusinessComponent },
      { path: 'business/:iTaxiLon_User', component: BusinessPageComponent },
      {
        path: 'payment', children: [
          { path: 'callback/prepayment', component: PaymentComponent },
          { path: 'callback', component: FullPaymentComponent },
        ]
      },
    ]
  },
  {
    path: 'partners', component: LandingPageComponent, children: [
      { path: '', component: HomeMarketersComponent },
      { path: 'dashboard', component: PartnerDashboardComponent, canActivate: [PartnerGuard] },
      { path: 'my-trips', component: PartnerTripsComponent, canActivate: [PartnerGuard] },
      { path: 'financial-report', component: PartnerFinancialComponent, canActivate: [PartnerGuard] },
      { path: 'account', component: PartnerDashboardComponent, canActivate: [PartnerGuard] },
    ]

  },

  { path: '**', redirectTo: '/home', pathMatch: 'full' },


];

@NgModule({

  imports: [

    RouterModule.forRoot(routes),

  ],

  exports: [RouterModule]

})

export class AppRoutingModule { }
